module.exports = __webpack_public_path__ + "static/media/mic.0e4d7114.svg";